import React, { useEffect, useRef, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Input,
  Label,
  CardText,
  Button,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { connect } from "react-redux";
import * as url from "../../helpers/url_helper";
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import { setBreadcrumbItems } from "../../store/actions";
import { toast } from "react-toastify";
import Select from "react-select";
import { Link, useNavigate } from "react-router-dom";

const NewUser = (props) => {
  const [isLoading, setLoading] = useState(false);
  const [userDetails, setUserDetails] = useState({
    firstName: "",
    lastName: "",
    mobile: "",
    email: "",
    countryCode: "",
    postcode: "",
    pincode: "",
    state: "",
    city: "",
    country: "",
    dob: "",
    gender: "",
    bloodGroup: "",
    resident_type: "",
    category: "",
  });
  const [OtherType, setOtherType] = useState(true);
  const [OtherTypeStyle, setOtherTypeStyle] = useState({
    backgroundColor: "#f3f4f6",
    color: "#6b7280",
    cursor: "not-allowed",
  });
  const [activeTab, setActiveTab] = useState("1");

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };
  const navigate = useNavigate();
  const [countryCode, setCountryCode] = useState([]);
  const [phoneCode, setPhoneCode] = useState([]);
  const [showArea, setShowArea] = useState(false);
  const [LoadingText, setLoadingText] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [postcodeDropdown, setPostCodeDropdown] = useState(false);
  const [countryDropdown, setCountryDropDown] = useState(false);
  const flatpickrRef = useRef(null);
  const [areas, setAreas] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("");
  const [countryList, setCountryCodeList] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [errors, setErrors] = useState({});
  const [emailErrors, setEmailErrors] = useState("");
  const [mobileErrors, setMobileErrors] = useState("");
  const [validate, setValidate] = useState(false);
  const [area, setArea] = useState(null);
  const [isEmailValid, setIsEmailValid] = useState(false);
  const [isMobileValid, setIsMobileValid] = useState(false);
  const [emailStatus, setEmailStatus] = useState("idle"); // idle | checking | exists | available
  const [emailMessage, setEmailMessage] = useState("");
  const [mobileStatus, setMobileStatus] = useState("idle"); // idle | checking | exists | available
  const [mobileMessage, setMobileMessage] = useState("");
  const [locationType, setLocationType] = useState({});
  const [checkingEmail, setCheckingEmail] = useState(false);
  const [checkingMobile, setCheckingMobile] = useState(false);
  const [disabledBtn, setDisabledBtn] = useState(true);
  const [categoryList, setCategoryList] = useState([]);
  const ProfessionObj = [
    { value: "State Gov. Job", label: "State Gov. Job" },
    { value: "Central Gov. Job", label: "Central Gov. Job" },
    { value: "Doctor", label: "Doctor" },
    { value: "Engineer", label: "Engineer" },
    { value: "Advocate", label: "Advocate" },
    { value: "Business", label: "Business" },
    { value: "Retired", label: "Retired" },
    { value: "Teacher", label: "Teacher" },
    { value: "Farmer", label: "Farmer" },
    { value: "Homemaker(Housewife)", label: "Homemaker(Housewife)" },
    { value: "Others", label: "Others" },
  ];
  const breadcrumbItems = [
    { title: "VUF", link: "#" },
    { title: "User List", link: "#" },
    { title: "User Add", link: "#" },
  ];
  useEffect(() => {
    getCategory();
    props.setBreadcrumbItems("Add User", breadcrumbItems);
  }, []);

  const ChangeLocation = async (location) => {
    if (location === "Indian Resident") {
      setCountryDropDown(false);
      setPostCodeDropdown(false);
      setPhoneCode("91");
    } else {
      setPhoneCode("");
      countryListWithCode();
      setPostCodeDropdown(true);
      setCountryDropDown(true);
    }
  };

  const getVerificationResult = (result) => {
    const errorText = typeof result?.error === "string" ? result.error : "";
    const messageText = typeof result?.message === "string" ? result.message : "";
    const responseText = `${errorText} ${messageText}`.toLowerCase();

    const isAlreadyRegisteredByFlag = result?.status === true && result?.auth === true;
    const isAlreadyRegisteredByMessage =
      /already\s*(registered|exist)|already\s*exists|user\s*already/.test(
        responseText,
      );

    const isAvailableByMessage =
      /not\s*registered|not\s*found|does\s*not\s*exist|user\s*is\s*valid|available/.test(
        responseText,
      );

    if (isAlreadyRegisteredByFlag || isAlreadyRegisteredByMessage) {
      return {
        status: "exists",
        message: "Already registered in database. Please use another value.",
      };
    }

    if (isAvailableByMessage) {
      return {
        status: "available",
        message: "Verified in database. You can register with this value.",
      };
    }

    return {
      status: "unknown",
      message: "Unable to verify from database. Please try checking again.",
    };
  };

  const checkEmailExists = async (email) => {
    try {
      setEmailStatus("checking");
      setEmailMessage("");
      setCheckingEmail(true);
      setDisabledBtn(true);
      const response = await fetch(url.AUTH_URL + "check-email-registered", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: email,
          // client: "SSO",
          // client_secret: "fw!@y88ss0$o8",
          client: "VUFAPP",
          client_secret: "fw!@y84oua$o3",
        }),
      });
      const result = await response.json();
      const verificationResult = getVerificationResult(result);

      if (verificationResult.status === "exists") {
        setEmailStatus("exists");
        setEmailMessage("This email is already registered.");
        setIsEmailValid(false);
        setDisabledBtn(true);
      } else if (verificationResult.status === "available") {
        setEmailStatus("available");
        setEmailMessage("Email verified. You can register this email.");
        setIsEmailValid(true);
        setDisabledBtn(false);
      } else {
        setEmailStatus("exists");
        setEmailMessage("Unable to verify email from database. Please recheck.");
        setIsEmailValid(false);
        setDisabledBtn(true);
      }
    } catch (err) {
      console.error(err);
      setEmailStatus("exists");
      setEmailMessage("Email check failed due to server issue. Please retry.");
      setIsEmailValid(false);
      setDisabledBtn(true);
    } finally {
      setCheckingEmail(false);
    }
  };
  const checkMobileExists = async (mobile) => {
    try {
      setMobileStatus("checking");
      setMobileMessage("");
      setCheckingMobile(true);
      setDisabledBtn(true);
      const resolvedCountryCode =
        locationType?.label === "Indian Resident"
          ? "+91"
          : phoneCode
            ? `+${phoneCode}`
            : "";

      const response = await fetch(url.AUTH_URL + "check-mobile-registered", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          mobileNo: mobile,
          countryCode: resolvedCountryCode,
          // client: "SSO",
          // client_secret: "fw!@y88ss0$o8",
          client: "VUFAPP",
          client_secret: "fw!@y84oua$o3",
        }),
      });
      const result = await response.json();
      const verificationResult = getVerificationResult(result);

      if (verificationResult.status === "exists") {
        setMobileStatus("exists");
        setMobileMessage("This mobile number is already registered.");
        setIsMobileValid(false);
        setDisabledBtn(true);
      } else if (verificationResult.status === "available") {
        setMobileStatus("available");
        setMobileMessage("Mobile verified. You can register this number.");
        setIsMobileValid(true);
        setDisabledBtn(false);
      } else {
        setMobileStatus("exists");
        setMobileMessage("Unable to verify mobile from database. Please recheck.");
        setIsMobileValid(false);
        setDisabledBtn(true);
      }
    } catch (err) {
      console.error(err);
      setMobileStatus("exists");
      setMobileMessage("Mobile check failed due to server issue. Please retry.");
      setIsMobileValid(false);
      setDisabledBtn(true);
    } finally {
      setCheckingMobile(false);
    }
  };
  const getCategory = async (mobile) => {
    try {
      setCheckingMobile(true);
      setDisabledBtn(true);
      const response = await fetch(url.VUF_APP_API + "category/get-category", {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      const result = await response.json();

      if (result.status) {
        const resData = result.response;
        const list = resData.map((item) => ({
          label: item.name,
          value: item._id,
        }));
        setCategoryList(list);
      } else {
        setDisabledBtn(false);
        setErrors({});
        setIsMobileValid(true);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setCheckingMobile(false);
    }
  };
  const customStyles = `
    .custom-tabs {
      border-bottom: 2px solid #edf2f7;
      display: flex;
      gap: 8px;
    }
    .custom-tabs .nav-link {
      border: none !important;
      color: #718096 !important;
      font-weight: 500;
      padding: 10px 20px;
      transition: all 0.2s ease-in-out;
      background: transparent !important;
      cursor: pointer;
    }
    .custom-tabs .nav-link:hover {
      color: #2d3748 !important;
      background-color: #f7fafc !important;
    }
    .custom-tabs .nav-link.active {
      color: #2563eb !important;
      position: relative;
      background: transparent !important;
    }
    .custom-tabs .nav-link.active::after {
      content: "";
      position: absolute;
      bottom: -2px;
      left: 0;
      width: 100%;
      height: 3px;
      background-color: #2563eb;
      border-radius: 10px 10px 0 0;
    }
  `;
  const CheckValidation = () => {
    let tempErrors = {};
    let isValid = true;

    if (!userDetails.firstName || !userDetails.lastName) {
      tempErrors.name = "Please enter both first and last name";
      isValid = false;
      setDisabledBtn(true);
    }

    if (!userDetails.resident_type) {
      tempErrors.resident_type = "Please select resident type";
      isValid = false;
      setDisabledBtn(true);
    }

    if (!userDetails.mobile) {
      tempErrors.mobile = "Please enter mobile number";
      isValid = false;
      setDisabledBtn(true);
    }

    if (!userDetails.gender) {
      tempErrors.gender = "Please select gender";
      isValid = false;
      setDisabledBtn(true);
    }

    // if (!userDetails.bloodGroup) {
    //   tempErrors.bloodGroup = "Please select blood group";
    //   isValid = false;
    //   setDisabledBtn(true);
    // }

    if (userDetails.resident_type === "NRI" && !userDetails.country) {
      tempErrors.country = "Please select country";
      isValid = false;
      setDisabledBtn(true);
    }

    // if (!isMobileValid) {
    //   tempErrors.mobile = "Please enter another Mobile no.";
    //   isValid = false;
    // } else if (!isEmailValid) {
    //   tempErrors.email = "Please enter another Email";
    //   isValid = false;
    // }

    setErrors(tempErrors);
    setValidate(isValid);
    setDisabledBtn(false);
    return isValid;
  };

  const handleAddDetails = async (id) => {
    try {
      if (CheckValidation()) {
        let cCode = "";
        if (locationType.label === "Indian Resident") {
          cCode = "+91";
        } else {
          cCode = "+" + phoneCode;
        }
        let urlPath = `user`;
        let payload = {
          client: "VUFAPP",
          client_secret: "fw!@y84oua$o3",
          firstName: userDetails.firstName,
          lastName: userDetails.lastName,
          mobileNo: userDetails.mobile,
          resident_type: userDetails.resident_type,
          countryCode: cCode,
          email: userDetails.email,
          dob: userDetails.dob || null,
          bloodgroup: userDetails.bloodGroup,
          area: userDetails.area,
          gender: userDetails.gender,
          pincode: userDetails.pincode,
          profession: userDetails.profession,
          otherProfession: userDetails.otherProfession,
          street_address: userDetails.street_address,
          country: selectedCountry ? selectedCountry : userDetails.country,
          state: selectedState ? selectedState : userDetails.state,
          district: selectedDistrict ? selectedDistrict : userDetails.district,
          city: selectedCity ? selectedCity : userDetails.city,
        };

        const response = await fetch(url.AUTH_URL + urlPath, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });

        const result = await response.json();

        if (result.status) {
          setShowArea(false);
          toast.success("User successfully created!");
          setTimeout(() => {
            navigate("/UserList");
          }, 2000);
          setLoading(false);
        } else {
          toast.error(result.error);
        }
      } else {
        if (!isEmailValid || !isMobileValid) {
          toast.error(
            "This email or mobile number is already registered. Please try another one.",
          );
        } else {
          toast.error("Form has errors.");
        }
      }
    } catch (error) {
      console.error("Update error:", error);
      toast.warn("Something went wrong!");
    }
  };
  const handleAddOrganizationDetails = async (id) => {
    try {
      let urlPath = `create-organization-user`;
      let payload = {
        client: "VUFAPP",
        client_secret: "fw!@y84oua$o3",
        firstName: userDetails.firstName,
        mobileNo: userDetails.mobile,
        category: userDetails.category,
        countryCode: "+91",
        area: userDetails.area,
        pincode: userDetails.pincode,
        street_address: userDetails.street_address,
        country: selectedCountry ? selectedCountry : userDetails.country,
        state: selectedState ? selectedState : userDetails.state,
        district: selectedDistrict ? selectedDistrict : userDetails.district,
        city: selectedCity ? selectedCity : userDetails.city,
      };
      const token = localStorage.getItem("token");
      const response = await fetch(url.AUTH_URL + urlPath, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (result.status) {
        setShowArea(false);
        toast.success("Organization successfully created!");
        setTimeout(() => {
          navigate("/UserList");
        }, 2000);
        setLoading(false);
      } else {
        toast.error(result.error);
      }
    } catch (error) {
      console.error("Update error:", error);
      toast.warn("Something went wrong!");
    }
  };
  function onChangePostcode(pincode) {
    if (!pincode) {
      clearAddressFields();
      return;
    }
    let urlPath;
    if (locationType.label == "NRI") {
      urlPath = `auth/nriPostalCode/us/${pincode}`;
    } else {
      urlPath = `auth/PostalCode/${pincode}`;
    }
    setLoadingText(true);
    setDisabled(true);
    fetch(`${url.VUF_APP_API}${urlPath}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (locationType.label == "NRI") {
          if (data.status) {
            const responseData = data.response;
            setLoadingText(false);
            setDisabled(false);
            const areaList = responseData.map((data) => ({
              label: data.city,
              id: data.city,
              Code: data.postalCode,
            }));
            const fullAddress = [
              responseData[0].city,
              responseData[0].state,
              responseData[0].country,
            ]
              .filter(Boolean)
              .join(", ");

            setUserDetails((prev) => ({
              ...prev,
              address2: fullAddress,
              city: responseData[0].city,
              state: responseData[0].state,
              country: responseData[0].country,
            }));
            setSelectedCountry(responseData[0].country);
            // setSelectedCountry(firstOffice.country || "");
            // setSelectedState(firstOffice.State || "");
            // setSelectedDistrict(firstOffice.District || "");
            // setSelectedCity(firstOffice.Block || "");
            setAreas(areaList);
          }
        } else {
          if (data?.status) {
            const postOffices = data.response?.[0]?.PostOffice || [];

            if (postOffices.length > 0) {
              const firstOffice = postOffices[0];

              const fullAddress = [
                firstOffice.Block,
                firstOffice.District,
                firstOffice.State,
                firstOffice.Country,
              ]
                .filter(Boolean)
                .join(", ");

              setUserDetails((prev) => ({
                ...prev,
                address2: fullAddress,
              }));

              // If you still want separate state variables for other uses
              setSelectedCountry(firstOffice.Country || "");
              setSelectedState(firstOffice.State || "");
              setSelectedDistrict(firstOffice.District || "");
              setSelectedCity(firstOffice.Block || "");

              const areasList = postOffices.map((office) => ({
                label: office.Name,
                id: office.Name,
                Code: office.Name,
              }));
              setAreas(areasList);
              setLoadingText(false);
              setDisabled(false);
              setErrors((prev) => ({ ...prev, Pincode: "" }));
            } else {
              handleInvalidPincode();
              setLoadingText(false);
              setDisabled(true);
            }
          } else {
            setLoadingText(false);
            setDisabled(true);
            handleInvalidPincode();
          }
        }
      })
      .catch((error) => {
        console.error("Pincode fetch error:", error);
        toast.warn("Something went wrong, please try again later.");
      });
  }
  function countryListWithCode(location) {
    const urlPath = `auth/CountryList`;
    setLoadingText(true);
    setDisabled(true);
    fetch(`${url.VUF_APP_API}${urlPath}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status) {
          const list = data.response;
          const options = list
            // .filter((country) => country.country_name !== "India")
            .map((country) => ({
              label: country.country_name,
              value: country.phonecode,
              code: country.country_code,
            }));
          setCountryCodeList(options);
        }
      })
      .catch((error) => {
        console.error("Pincode fetch error:", error);
        toast.warn("Something went wrong, please try again later.");
      });
  }
  function handleInvalidPincode() {
    clearAddressFields();
    toast.error("Please enter correct pincode.");
  }

  function clearAddressFields() {
    setSelectedCountry("");
    setSelectedState("");
    setSelectedDistrict("");
    setSelectedCity("");
    setArea("");
    setAreas([]);
  }
  const getProfessional = (type) => {
    if (type === "Others") {
      setOtherType(false);
      setOtherTypeStyle({
        backgroundColor: "",
        color: "#6b7280",
        cursor: "",
      });
    } else {
      setOtherTypeStyle({
        backgroundColor: "#f3f4f6",
        color: "#6b7280",
        cursor: "not-allowed",
      });
      setOtherType(true);
    }
  };
  return (
    <React.Fragment>
      {isLoading ? (
        <Spinners />
      ) : (
        <Row>
          <Col xl="12">
            <Card>
              <CardHeader>
                <Row>
                  {/* <Col md="9">
                    <CardTitle className="h4 mb-0">Create User</CardTitle>
                  </Col> */}
                </Row>
              </CardHeader>
              <CardBody>
                {/* <style>{customStyles}</style>
                <Nav tabs className="custom-tabs">
                  <NavItem>
                    <NavLink
                      className={activeTab === "1" ? "active" : ""}
                      onClick={() => toggle("1")}
                    >
                      User
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={activeTab === "2" ? "active" : ""}
                      onClick={() => toggle("2")}
                    >
                      Organization
                    </NavLink>
                  </NavItem>
                </Nav> */}
                <div
                  className="container"
                  style={{ maxWidth: "100%", margin: "0px" }}
                >
                  <TabContent activeTab={activeTab} className="mt-3">
                    <TabPane tabId="1">
                      <Row>
                        <Col sm="12">
                          <div className="row">
                            <div className="col-md-12">
                              <form
                                onSubmit={(e) => {
                                  e.preventDefault();
                                  handleAddDetails();
                                }}
                              >
                                <div className="row">
                                  <div className="col-md-3">
                                    <div
                                      className="form-group"
                                      style={{ marginBottom: "15px" }}
                                    >
                                      <Label
                                        className={`form-label ${errors?.firstName ? "text-danger" : ""}`}
                                      >
                                        First Name
                                        <span className="text-danger ms-1">
                                          *
                                        </span>
                                      </Label>

                                      <input
                                        type="text"
                                        name="firstName"
                                        className={`form-control ${
                                          errors?.firstName
                                            ? "is-invalid"
                                            : validate
                                              ? "is-valid"
                                              : ""
                                        }`}
                                        value={userDetails.firstName || ""}
                                        onChange={(e) => {
                                          setUserDetails({
                                            ...userDetails,
                                            firstName: e.target.value,
                                          });
                                        }}
                                      />

                                      {errors?.firstName && (
                                        <div className="invalid-feedback">
                                          {errors.firstName}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-md-3">
                                    <div
                                      className="form-group"
                                      style={{ marginBottom: "15px" }}
                                    >
                                      <Label
                                        className={`form-label ${errors?.lName ? "text-danger" : ""}`}
                                      >
                                        Last Name
                                        <span className="text-danger ms-1">
                                          *
                                        </span>
                                      </Label>
                                      <input
                                        type="text"
                                        name="lastName"
                                        className={`form-control ${errors?.lastName ? "is-invalid" : ""}`}
                                        value={userDetails.lastName}
                                        onChange={(e) =>
                                          setUserDetails({
                                            ...userDetails,
                                            lastName: e.target.value,
                                          })
                                        }
                                      />
                                      {errors.lName && (
                                        <div className="invalid-feedback">
                                          {errors.lName}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-md-3">
                                    <div className="form-group">
                                      <Label
                                        className={`form-label ${errors?.resident_type ? "text-danger" : ""}`}
                                      >
                                        Resident Type
                                        <span className="text-danger ms-1">
                                          *
                                        </span>
                                      </Label>
                                      <select
                                        name="location_type"
                                        className={`form-control border-1 shadow-none ${errors?.resident_type ? "is-invalid" : ""}`}
                                        onChange={(e) => {
                                          setLocationType(e.target.value);
                                          ChangeLocation(e.target.value);
                                          countryListWithCode(e.target.value);
                                          setUserDetails({
                                            ...userDetails,
                                            resident_type: e.target.value,
                                          });
                                        }}
                                      >
                                        <option value="">
                                          Select Resident Type
                                        </option>
                                        <option value="Indian Resident">
                                          Indian Resident
                                        </option>
                                        <option value="NRI">NRI</option>
                                      </select>
                                      {errors?.lName && (
                                        <div className="invalid-feedback">
                                          {errors?.lName}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  {countryDropdown && (
                                    <div className="col-md-3">
                                      <div className="form-group">
                                        <Label
                                          className={`form-label ${errors?.country ? "is-invalid" : ""}`}
                                        >
                                          Country
                                          <span className="text-danger ms-1">
                                            *
                                          </span>
                                        </Label>
                                        <Select
                                          name="location_type"
                                          className={`select2-selection border-1 shadow-none ${errors?.mobile ? "is-invalid" : ""}`}
                                          options={countryList}
                                          onChange={(selectedOption) => {
                                            setCountryCode(selectedOption.code);
                                            setPhoneCode(selectedOption.value);
                                          }}
                                        />
                                        {errors?.country && (
                                          <div className="invalid-feedback">
                                            {errors?.country}
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  )}

                                  <div className="col-md-3">
                                    <div
                                      className="form-group"
                                      style={{ marginBottom: "5px" }}
                                    >
                                      <Label>Email</Label>

                                      <div className="d-flex gap-2">
                                        <Input
                                          type="email"
                                          className={`form-control ${
                                            emailStatus === "exists"
                                              ? "is-invalid"
                                              : emailStatus === "available"
                                                ? "is-valid"
                                                : ""
                                          }`}
                                          value={userDetails.email}
                                          onChange={(e) => {
                                            const value =
                                              e.target.value.replace(
                                                /[^a-zA-Z0-9@._-]/g,
                                                "",
                                              );

                                            setUserDetails({
                                              ...userDetails,
                                              email: value,
                                            });

                                            setEmailStatus("idle");
                                            setEmailMessage("");
                                            setIsEmailValid(false);
                                          }}
                                          placeholder="Enter email"
                                        />

                                        <button
                                          type="button"
                                          className="btn btn-outline-primary"
                                          disabled={
                                            !userDetails.email || checkingEmail
                                          }
                                          onClick={() =>
                                            checkEmailExists(userDetails.email)
                                          }
                                        >
                                          {checkingEmail
                                            ? "Checking..."
                                            : "Check"}
                                        </button>
                                      </div>

                                      {emailStatus === "checking" && (
                                        <small className="text-info">
                                          <i className="fas fa-spinner fa-spin me-1"></i>
                                          Checking email...
                                        </small>
                                      )}

                                      {emailStatus === "exists" && (
                                        <div className="invalid-feedback d-block">
                                          <i className="fas fa-times-circle me-1"></i>
                                          {emailMessage}
                                        </div>
                                      )}

                                      {emailStatus === "available" && (
                                        <div className="valid-feedback d-block">
                                          <i className="fas fa-check-circle me-1"></i>
                                          {emailMessage}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-md-3">
                                    <div
                                      className="form-group"
                                      style={{ marginBottom: "5px" }}
                                    >
                                      <Label>Mobile</Label>

                                      <div className="d-flex gap-2">
                                        {locationType.label != "" &&
                                          countryCode &&
                                          phoneCode && (
                                            <span className="input-group-text">
                                              {""}+{phoneCode}
                                            </span>
                                          )}
                                        <Input
                                          type="text"
                                          maxLength={10}
                                          className={`form-control ${
                                            mobileStatus === "exists"
                                              ? "is-invalid"
                                              : mobileStatus === "available"
                                                ? "is-valid"
                                                : ""
                                          }`}
                                          value={userDetails.mobile}
                                          placeholder="Enter mobile number"
                                          onChange={(e) => {
                                            const value =
                                              e.target.value.replace(
                                                /[^0-9]/g,
                                                "",
                                              );

                                            setUserDetails({
                                              ...userDetails,
                                              mobile: value,
                                            });

                                            // reset validation when user edits
                                            setMobileStatus("idle");
                                            setMobileMessage("");
                                            setIsMobileValid(false);
                                          }}
                                        />

                                        <button
                                          type="button"
                                          className="btn btn-outline-primary"
                                          disabled={
                                            !userDetails.mobile ||
                                            userDetails.mobile.length !== 10 ||
                                            checkingMobile
                                          }
                                          onClick={() =>
                                            checkMobileExists(
                                              userDetails.mobile,
                                            )
                                          }
                                        >
                                          {checkingMobile
                                            ? "Checking..."
                                            : "Check"}
                                        </button>
                                      </div>

                                      {mobileStatus === "checking" && (
                                        <small className="text-info">
                                          <i className="fas fa-spinner fa-spin me-1"></i>
                                          Checking mobile...
                                        </small>
                                      )}

                                      {mobileStatus === "exists" && (
                                        <div className="invalid-feedback d-block">
                                          <i className="fas fa-times-circle me-1"></i>
                                          {mobileMessage}
                                        </div>
                                      )}

                                      {mobileStatus === "available" && (
                                        <div className="valid-feedback d-block">
                                          <i className="fas fa-check-circle me-1"></i>
                                          {mobileMessage}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-md-3">
                                    <div
                                      className="form-group"
                                      style={{ marginBottom: "15px" }}
                                    >
                                      <label
                                        className={`form-label ${errors?.gender ? "text-danger" : ""}`}
                                      >
                                        Gender{" "}
                                        <span className="text-danger ms-1">
                                          *
                                        </span>
                                      </label>
                                      <select
                                        value={userDetails.gender}
                                        onChange={(e) =>
                                          setUserDetails({
                                            ...userDetails,
                                            gender: e.target.value,
                                          })
                                        }
                                        className={`form-control select2-selection border-1 shadow-none ${errors?.gender ? "is-invalid" : ""}`}
                                      >
                                        <option value=" ">Select Gender</option>
                                        <option value="Male">Male</option>
                                        <option value="Female">Female</option>
                                      </select>
                                      {errors?.gender && (
                                        <div className="invalid-feedback">
                                          {errors?.gender}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-md-3">
                                    <div
                                      className="form-group"
                                      style={{ marginBottom: "15px" }}
                                    >
                                      <Label
                                        className={`form-label ${errors?.bloodGroup ? "text-danger" : ""}`}
                                      >
                                        Blood Group
                                        <span className="text-danger ms-1"></span>
                                      </Label>
                                      <select
                                        className={`form-control select2-selection border-1 shadow-none ${errors?.bloodGroup ? "is-invalid" : ""}`}
                                        id="blood-group"
                                        name="blood-group"
                                        value={userDetails.bloodGroup}
                                        onChange={(e) =>
                                          setUserDetails({
                                            ...userDetails,
                                            bloodGroup: e.target.value,
                                          })
                                        }
                                      >
                                        <option value="">
                                          Please choose an option
                                        </option>
                                        <option value="A+">
                                          A Positive (A+)
                                        </option>
                                        <option value="A-">
                                          A Negative (A-)
                                        </option>
                                        <option value="B+">
                                          B Positive (B+)
                                        </option>
                                        <option value="B-">
                                          B Negative (B-)
                                        </option>
                                        <option value="AB+">
                                          AB Positive (AB+)
                                        </option>
                                        <option value="AB-">
                                          AB Negative (AB-)
                                        </option>
                                        <option value="O+">
                                          O Positive (O+)
                                        </option>
                                        <option value="O-">
                                          O Negative (O-)
                                        </option>
                                        <option value=" ">Not Available</option>
                                      </select>
                                      {errors?.bloodGroup && (
                                        <div className="invalid-feedback">
                                          {errors?.bloodGroup}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-md-3">
                                    <div
                                      className="form-group"
                                      style={{ marginBottom: "15px" }}
                                    >
                                      <label>Profession</label>
                                      <select
                                        className="form-select select2-selection"
                                        placeholder="Select Type"
                                        value={userDetails.profession || ""}
                                        onChange={(e) => {
                                          getProfessional(e.target.value);
                                          setUserDetails({
                                            ...userDetails,
                                            profession: e.target.value,
                                          });
                                        }}
                                      >
                                        <option value="">
                                          Select Profession
                                        </option>
                                        {ProfessionObj.map((item, index) => (
                                          <option
                                            key={index}
                                            value={item.value}
                                          >
                                            {item.label}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  </div>
                                  <div className="col-md-3">
                                    <div className="form-group">
                                      <label>Please specify</label>
                                      <Input
                                        type="text"
                                        disabled={OtherType}
                                        className="form-control form-control-solid"
                                        value={
                                          userDetails.otherProfession || ""
                                        }
                                        style={OtherTypeStyle}
                                        onChange={(e) =>
                                          setUserDetails({
                                            ...userDetails,
                                            otherProfession: e.target.value,
                                          })
                                        }
                                        placeholder="Enter your profession"
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-3">
                                    <div className="form-group">
                                      <label>Date of Birth</label>
                                      <Flatpickr
                                        value={userDetails.dob}
                                        placeholder="Select Date"
                                        options={{
                                          dateFormat: "Y-m-d",
                                          maxDate: "today",
                                        }}
                                        onChange={(selectedDates, dateStr) =>
                                          setUserDetails({
                                            ...userDetails,
                                            dob: dateStr,
                                          })
                                        }
                                        ref={flatpickrRef}
                                      />
                                    </div>
                                  </div>
                                  {!postcodeDropdown ? (
                                    <>
                                      <div className="col-md-3">
                                        <label className="form-label">
                                          <b>Pin code</b>
                                        </label>
                                        <div className="form-group input-group">
                                          <Input
                                            type="text"
                                            className="form-control form-control-solid"
                                            pattern="^[0-9]{6}$"
                                            inputMode="numeric"
                                            onChange={(event) => {
                                              const onlyDigits =
                                                event.target.value.replace(
                                                  /\D/g,
                                                  "",
                                                );
                                              setUserDetails((prev) => ({
                                                ...prev,
                                                pincode: onlyDigits.slice(0, 6),
                                              }));
                                            }}
                                            placeholder="Enter Pincode"
                                            value={userDetails.pincode}
                                          />
                                          <button
                                            type="button"
                                            style={{
                                              outline: "none",
                                              transform: "none",
                                              boxShadow: "none",
                                            }}
                                            className="btn btn-outline-info"
                                            onClick={() => {
                                              setShowArea(true);
                                              onChangePostcode(
                                                userDetails.pincode,
                                              );
                                            }}
                                          >
                                            Fetch Area
                                          </button>
                                        </div>
                                      </div>
                                    </>
                                  ) : (
                                    <div className="col-md-3">
                                      <label className="form-label">
                                        <b>Post code</b>
                                      </label>
                                      <div className="form-group input-group">
                                        <Input
                                          type="text"
                                          className="form-control form-control-solid"
                                          pattern="^\d{5}(-\d{4})?$"
                                          inputMode="numeric"
                                          onChange={(event) => {
                                            const onlyDigits =
                                              event.target.value.replace(
                                                /\D/g,
                                                "",
                                              );
                                            setUserDetails((prev) => ({
                                              ...prev,
                                              pincode: onlyDigits.slice(0, 6),
                                            }));
                                          }}
                                          placeholder="Enter post code"
                                          value={userDetails.pincode}
                                        />
                                        <button
                                          type="button"
                                          style={{
                                            outline: "none",
                                            transform: "none",
                                            boxShadow: "none",
                                          }}
                                          className="btn btn-outline-info"
                                          onClick={() => {
                                            setShowArea(true);
                                            onChangePostcode(
                                              userDetails.pincode,
                                            );
                                          }}
                                        >
                                          Fetch Area
                                        </button>
                                      </div>
                                    </div>
                                  )}
                                  {showArea ? (
                                    <div className="col-md-3">
                                      <div className="form-group">
                                        <label>Area</label>
                                        <select
                                          disabled={disabled}
                                          onChange={(event) =>
                                            setUserDetails((prev) => ({
                                              ...prev,
                                              area: event.target.value,
                                            }))
                                          }
                                          className="form-select"
                                          value={userDetails.area || ""}
                                        >
                                          <option value="">Select Area</option>
                                          {areas.map((area) => (
                                            <option
                                              key={area.value}
                                              value={area.value}
                                            >
                                              {area.label}
                                            </option>
                                          ))}
                                        </select>
                                        {LoadingText ? (
                                          <span className="text-muted">
                                            Please wait… Loading
                                          </span>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="col-md-3">
                                      <div className="form-group">
                                        <label>Area: </label>
                                        <Input
                                          className="form-control form-control-solid"
                                          value={userDetails.area}
                                          readOnly={true}
                                          style={{
                                            backgroundColor: "#f3f4f6",
                                            color: "#6b7280",
                                            cursor: "not-allowed",
                                          }}
                                          onChange={(event) =>
                                            setUserDetails((prev) => ({
                                              ...prev,
                                              area: event.target.value,
                                            }))
                                          }
                                        />
                                      </div>
                                    </div>
                                  )}
                                  <div className="col-md-3">
                                    <div className="form-group">
                                      {locationType.label === "NRI" ? (
                                        <label className="form-label">
                                          City, State, Country:
                                        </label>
                                      ) : (
                                        <label className="form-label">
                                          City, District, State, Country:
                                        </label>
                                      )}
                                      <Input
                                        readOnly={true}
                                        type="text"
                                        className="form-control"
                                        value={userDetails.address2}
                                        style={{
                                          backgroundColor: "#f3f4f6",
                                          color: "#6b7280",
                                          cursor: "not-allowed",
                                        }}
                                        onChange={(event) =>
                                          setUserDetails((prev) => ({
                                            ...prev,
                                            address2: event.target.value,
                                          }))
                                        }
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <label>Address</label>
                                      <Input
                                        value={userDetails.street_address || ""}
                                        onChange={(event) =>
                                          setUserDetails((prev) => ({
                                            ...prev,
                                            street_address: event.target.value,
                                          }))
                                        }
                                      ></Input>
                                    </div>
                                  </div>
                                </div>

                                <div className="row">
                                  <div className="col-md-12">
                                    <div className="col-md-4">
                                      <button
                                        type="submit"
                                        disabled={disabledBtn}
                                        style={{
                                          outline: "none",
                                          transform: "none",
                                          boxShadow: "none",
                                        }}
                                        className="btn btn-outline-primary me-3"
                                      >
                                        <span className="fa fa-save me-2"></span>
                                        Save
                                      </button>
                                      <Link
                                        to={"/UserList"}
                                        className="btn btn-outline-danger"
                                      >
                                        <span className="menu-text fa fa-arrow-left me-2"></span>
                                        Cancel
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              </form>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </TabPane>

                    <TabPane tabId="2">
                      <Row>
                        <Col sm="12">
                          <form
                            onSubmit={(e) => {
                              e.preventDefault();
                              handleAddOrganizationDetails();
                            }}
                          >
                            <div className="row">
                              <div className="col-md-6">
                                <div
                                  className="form-group"
                                  style={{ marginBottom: "15px" }}
                                >
                                  <Label
                                    className={`form-label ${errors?.firstName ? "text-danger" : ""}`}
                                  >
                                    Organization Name
                                    <span className="text-danger ms-1">*</span>
                                  </Label>

                                  <input
                                    type="text"
                                    name="firstName"
                                    className={`form-control ${
                                      errors?.firstName
                                        ? "is-invalid"
                                        : validate
                                          ? "is-valid"
                                          : ""
                                    }`}
                                    value={userDetails.firstName || ""}
                                    onChange={(e) => {
                                      setUserDetails({
                                        ...userDetails,
                                        firstName: e.target.value,
                                      });
                                    }}
                                  />

                                  {errors?.firstName && (
                                    <div className="invalid-feedback">
                                      {errors.firstName}
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div className="col-md-3">
                                <div className="form-group">
                                  <Label
                                    className={`form-label ${errors?.category ? "text-danger" : ""}`}
                                  >
                                    Category
                                    <span className="text-danger ms-1">*</span>
                                  </Label>
                                  <Select
                                    options={categoryList}
                                    name="category"
                                    onChange={(selectedOption) => {
                                      setUserDetails({
                                        ...userDetails,
                                        category: selectedOption
                                          ? selectedOption.value
                                          : "",
                                      });
                                    }}
                                  ></Select>
                                  {errors?.lName && (
                                    <div className="invalid-feedback">
                                      {errors?.lName}
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div className="col-md-3">
                                <div
                                  className="form-group"
                                  style={{ marginBottom: "5px" }}
                                >
                                  <Label>Mobile</Label>

                                  <div className="d-flex gap-2">
                                    <Input
                                      type="text"
                                      maxLength={10}
                                      className={`form-control ${
                                        errors?.mobile
                                          ? "is-invalid"
                                          : isMobileValid
                                            ? "is-valid"
                                            : ""
                                      }`}
                                      value={userDetails.mobile}
                                      placeholder="Enter mobile number"
                                      onChange={(e) => {
                                        const value = e.target.value.replace(
                                          /[^0-9]/g,
                                          "",
                                        );

                                        setUserDetails({
                                          ...userDetails,
                                          mobile: value,
                                        });

                                        // reset validation when user edits
                                        setIsMobileValid(false);
                                      }}
                                    />
                                  </div>

                                  {errors?.mobile && (
                                    <div className="invalid-feedback d-block">
                                      {errors.mobile}
                                    </div>
                                  )}
                                </div>
                              </div>

                              {!postcodeDropdown ? (
                                <>
                                  <div className="col-md-3">
                                    <label className="form-label">
                                      <b>Pin code</b>
                                    </label>
                                    <div className="form-group input-group">
                                      <Input
                                        type="text"
                                        className="form-control form-control-solid"
                                        pattern="^[0-9]{6}$"
                                        inputMode="numeric"
                                        onChange={(event) => {
                                          const onlyDigits =
                                            event.target.value.replace(
                                              /\D/g,
                                              "",
                                            );
                                          setUserDetails((prev) => ({
                                            ...prev,
                                            pincode: onlyDigits.slice(0, 6),
                                          }));
                                        }}
                                        placeholder="Enter Pincode"
                                        value={userDetails.pincode}
                                      />
                                      <button
                                        type="button"
                                        style={{
                                          outline: "none",
                                          transform: "none",
                                          boxShadow: "none",
                                        }}
                                        className="btn btn-outline-info"
                                        onClick={() => {
                                          setShowArea(true);
                                          onChangePostcode(userDetails.pincode);
                                        }}
                                      >
                                        Fetch Area
                                      </button>
                                    </div>
                                  </div>
                                </>
                              ) : (
                                <div className="col-md-3">
                                  <label className="form-label">
                                    <b>Post code</b>
                                  </label>
                                  <div className="form-group input-group">
                                    <Input
                                      type="text"
                                      className="form-control form-control-solid"
                                      pattern="^\d{5}(-\d{4})?$"
                                      inputMode="numeric"
                                      onChange={(event) => {
                                        const onlyDigits =
                                          event.target.value.replace(/\D/g, "");
                                        setUserDetails((prev) => ({
                                          ...prev,
                                          pincode: onlyDigits.slice(0, 6),
                                        }));
                                      }}
                                      placeholder="Enter post code"
                                      value={userDetails.pincode}
                                    />
                                    <button
                                      type="button"
                                      style={{
                                        outline: "none",
                                        transform: "none",
                                        boxShadow: "none",
                                      }}
                                      className="btn btn-outline-info"
                                      onClick={() => {
                                        setShowArea(true);
                                        onChangePostcode(userDetails.pincode);
                                      }}
                                    >
                                      Fetch Area
                                    </button>
                                  </div>
                                </div>
                              )}
                              {showArea ? (
                                <div className="col-md-3">
                                  <div className="form-group">
                                    <label>Area</label>
                                    <select
                                      disabled={disabled}
                                      onChange={(event) =>
                                        setUserDetails((prev) => ({
                                          ...prev,
                                          area: event.target.value,
                                        }))
                                      }
                                      className="form-select"
                                      value={userDetails.area || ""}
                                    >
                                      <option value="">Select Area</option>
                                      {areas.map((area) => (
                                        <option
                                          key={area.value}
                                          value={area.value}
                                        >
                                          {area.label}
                                        </option>
                                      ))}
                                    </select>
                                    {LoadingText ? (
                                      <span className="text-muted">
                                        Please wait… Loading
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </div>
                              ) : (
                                <div className="col-md-3">
                                  <div className="form-group">
                                    <label>Area: </label>
                                    <Input
                                      className="form-control form-control-solid"
                                      value={userDetails.area}
                                      readOnly={true}
                                      style={{
                                        backgroundColor: "#f3f4f6",
                                        color: "#6b7280",
                                        cursor: "not-allowed",
                                      }}
                                      onChange={(event) =>
                                        setUserDetails((prev) => ({
                                          ...prev,
                                          area: event.target.value,
                                        }))
                                      }
                                    />
                                  </div>
                                </div>
                              )}
                              <div className="col-md-3">
                                <div className="form-group">
                                  {locationType.label === "NRI" ? (
                                    <label className="form-label">
                                      City, State, Country:
                                    </label>
                                  ) : (
                                    <label className="form-label">
                                      City, District, State, Country:
                                    </label>
                                  )}
                                  <Input
                                    readOnly={true}
                                    type="text"
                                    className="form-control"
                                    value={userDetails.address2}
                                    style={{
                                      backgroundColor: "#f3f4f6",
                                      color: "#6b7280",
                                      cursor: "not-allowed",
                                    }}
                                    onChange={(event) =>
                                      setUserDetails((prev) => ({
                                        ...prev,
                                        address2: event.target.value,
                                      }))
                                    }
                                  />
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label>Address</label>
                                  <Input
                                    value={userDetails.street_address || ""}
                                    onChange={(event) =>
                                      setUserDetails((prev) => ({
                                        ...prev,
                                        street_address: event.target.value,
                                      }))
                                    }
                                  ></Input>
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-md-12">
                                <div className="col-md-4">
                                  <button
                                    type="submit"
                                    className="btn btn-outline-primary me-3"
                                  >
                                    <span className="fa fa-save me-2"></span>
                                    Save
                                  </button>
                                  <Link
                                    to={"/UserList"}
                                    className="btn btn-outline-danger"
                                  >
                                    <span className="menu-text fa fa-arrow-left me-2"></span>
                                    Cancel
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </form>
                        </Col>
                      </Row>
                    </TabPane>
                  </TabContent>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </React.Fragment>
  );
};
export default connect(null, { setBreadcrumbItems })(NewUser);
